import { render, staticRenderFns } from "./ButtonStrongHover.vue?vue&type=template&id=4f045274&scoped=true&lang=pug&"
import script from "./ButtonStrongHover.vue?vue&type=script&lang=ts&"
export * from "./ButtonStrongHover.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonStrongHover.vue?vue&type=style&index=0&id=4f045274&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f045274",
  null
  
)

export default component.exports